import { createContext, useEffect, useState } from "react";
import { Agreement, VendorsApi } from "@sb1finans/new-api/dist/api"

interface AgreementContextProps {
    agreements?: Agreement[]
    activeAgreementId?: string
    isFetching: boolean,
    setActiveAgreementId: (agreementId: string | undefined) => void
    error?: Error
}
  
const defaultContext = {
  isFetching: true,
  agreements: [],
  activeAgreementId: undefined,
  setActiveAgreementId: (agreementId: string | undefined) => {},
  error: undefined
}

export const AgreementContext  = createContext<AgreementContextProps>(defaultContext)

interface AgreementProviderProps {
    children: React.ReactNode
    vendorsApi: VendorsApi
}

export const AgreementProvider: React.FC<AgreementProviderProps> = ({children, vendorsApi}) => {

  const [agreements, setAgreements] = useState<Agreement[] | undefined>(undefined)
  const [activeAgreementId, setActiveAgreementId] = useState<string | undefined>(undefined)
  const [isFetching, setIsFetching] = useState<boolean>(true)
  const [error, setError] = useState<Error | undefined>()

  useEffect(() => {
    vendorsApi
      ?.listVendors()
      .then((res) => {
        setAgreements(res.data)
        setIsFetching(false)
      })
      .catch((error) => {
        setError(error)
        setIsFetching(false)
      })
  }, [])

  //const activeAgreementId = agreements?.length ? agreements[0].id : undefined
  const active = activeAgreementId ?? agreements?.[0].id

  return <AgreementContext.Provider value={{agreements, activeAgreementId: active, setActiveAgreementId, isFetching, error}}>
        {children}
    </AgreementContext.Provider>
}